const swiper = new Swiper('.kuvagalleria__kuvat', {
  spaceBetween: 20,
  slidesPerView: "auto",
});